import { backendApi } from "../dynamicBAseQuery";

export const reportsApi = backendApi.injectEndpoints({
    overrideExisting: true,
    endpoints: (builder) => ({
        // Recruiter Tracker List Screen Api's
        recruiterTrackerReportList: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: `recruiterTrackerReportList`,
                body: { ...args }
            })
        }),

        sourcedByReportDownload: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: `sourcedByReportDownload`,
                body: { ...args }
            })
        }),

        profileInRecruiterTrackerDialog: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: `profileInRecruiterTracker`,
                body: { ...args }
            })
        }),

        // Manage Events Reports Screen Api's
        getManageEventList: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: `getPositionEventList`,
                body: { ...args }
            })
        }),

        jobDescForParticularClient: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: `jobDescForParticularClient`,
                body: { ...args }
            })
        }),

        getPositionEventReport: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: `getPositionEventReport`,
                body: { ...args }
            })
        }),

        clientHiringList: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: `clientHiringList`,
                params: args
            })
        }),
    })
})

export const {
    // Tracker List Screen
    useRecruiterTrackerReportListMutation,
    useSourcedByReportDownloadMutation,
    useProfileInRecruiterTrackerDialogMutation,

    //Manage Events Reports screen
    useGetManageEventListMutation,
    useJobDescForParticularClientMutation,
    useGetPositionEventReportMutation,
    useClientHiringListMutation,
} = reportsApi